import React, { Fragment, useMemo, useCallback } from 'react'

import { ProgressBar, StepError } from '../'
import { setMatchMakerQuestion } from '../../../../services/match-maker'

const OptionBox = ({ children, selected, onClick }) => (
  <div
    className={
      selected
        ? 'fifth_question__option__item fifth_question__option__item--active '
        : 'fifth_question__option__item'
    }
    onClick={onClick}
  >
    {children}
  </div>
)

const FifthStep = ({ state, dispatch, goToNextStep, goToPreviousStep, maxSteps }) => {
  const {
    form_values: { important_characteristics }
  } = useMemo(() => state, [state.form_values.important_characteristics])

  const submitFifthStep = useCallback(async () => {
    dispatch({ type: 'set_status', payload: 'loading' })
    try {
      const { data } = await setMatchMakerQuestion({
        id_session: state.id_session,
        answers: [
          {
            question: state.questions[5].id,
            answer: state.form_values.important_characteristics.empathy
          },
          {
            question: state.questions[6].id,
            answer: state.form_values.important_characteristics.career_time
          },
          {
            question: state.questions[7].id,
            answer: state.form_values.important_characteristics.punctuality
          },
          {
            question: state.questions[8].id,
            answer: state.form_values.important_characteristics.locality
          },
          {
            question: state.questions[9].id,
            answer: state.form_values.important_characteristics.patience
          }
        ]
      })
      goToNextStep(data)
    } catch {
      dispatch({ type: 'set_status', payload: 'error' })
    }
  }, [state.form_values.important_characteristics])

  const isFifthStepProgressDisabled = useCallback(() => {
    const { career_time, empathy, patience, locality, punctuality } = important_characteristics
    const isLocationPreferenceOnline =
      state.form_values.location_preference === 'online' || !state.isPresentialConsultationsEnable
    const areValuesGreaterThanZero = career_time > 0 && empathy > 0 && punctuality > 0

    if (isLocationPreferenceOnline && areValuesGreaterThanZero && patience > 0) {
      return false
    }

    if (!isLocationPreferenceOnline && areValuesGreaterThanZero && locality > 0) {
      return false
    }

    if (important_characteristics.points_remaining === 0) return false

    return true
  }, [state])

  if (state.status === 'error') {
    return <StepError stepImage='/static/images/match-maker/05.png' submitStep={submitFifthStep} />
  }

  return (
    <Fragment>
      <div className='step__illustration lg:hidden'>
        <img src='/static/images/match-maker/05.png' width='100%' />
      </div>
      <div className='step__question'>
        <p className='step__question__title'>Quais características você julga mais importante?</p>
        <p className='step__question__description'>
          Responda 1 para pouco importante e 5 para muito importante. A soma das notas não deve
          ultrapassar 15 pontos.
        </p>
        <div className='step__question__template mb-4'>
          <div className='fifth_question'>
            <div className='flex flex-col'>
              <div className='points-remaining-container'>
                <div className='fifth_question__points_remaining'>
                  <p>
                    {important_characteristics.points_remaining}{' '}
                    {important_characteristics.points_remaining === 1 ? 'ponto' : 'pontos'}
                    <span>
                      {important_characteristics.points_remaining === 1 ? 'Restante' : 'Restantes'}
                    </span>
                  </p>
                </div>
              </div>
              <div className='fifth_question__option'>
                <p>Empatia</p>
                <OptionBox
                  selected={important_characteristics.empathy === 1}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 1, field: 'empathy' }
                    })
                  }
                >
                  1
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.empathy === 2}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 2, field: 'empathy' }
                    })
                  }
                >
                  2
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.empathy === 3}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 3, field: 'empathy' }
                    })
                  }
                >
                  3
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.empathy === 4}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 4, field: 'empathy' }
                    })
                  }
                >
                  4
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.empathy === 5}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 5, field: 'empathy' }
                    })
                  }
                >
                  5
                </OptionBox>
              </div>
              <div className='fifth_question__option'>
                <p>Tempo de carreira</p>
                <OptionBox
                  selected={important_characteristics.career_time === 1}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 1, field: 'career_time' }
                    })
                  }
                >
                  1
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.career_time === 2}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 2, field: 'career_time' }
                    })
                  }
                >
                  2
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.career_time === 3}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 3, field: 'career_time' }
                    })
                  }
                >
                  3
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.career_time === 4}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 4, field: 'career_time' }
                    })
                  }
                >
                  4
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.career_time === 5}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 5, field: 'career_time' }
                    })
                  }
                >
                  5
                </OptionBox>
              </div>
              <div className='fifth_question__option'>
                <p>Pontualidade</p>
                <OptionBox
                  selected={important_characteristics.punctuality === 1}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 1, field: 'punctuality' }
                    })
                  }
                >
                  1
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.punctuality === 2}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 2, field: 'punctuality' }
                    })
                  }
                >
                  2
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.punctuality === 3}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 3, field: 'punctuality' }
                    })
                  }
                >
                  3
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.punctuality === 4}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 4, field: 'punctuality' }
                    })
                  }
                >
                  4
                </OptionBox>
                <OptionBox
                  selected={important_characteristics.punctuality === 5}
                  className='fifth_question__option__item'
                  onClick={() =>
                    dispatch({
                      type: 'set_important_characteristics',
                      payload: { value: 5, field: 'punctuality' }
                    })
                  }
                >
                  5
                </OptionBox>
              </div>
              {state.form_values.location_preference === 'online' ||
              !state.isPresentialConsultationsEnable ? (
                <div className='fifth_question__option'>
                  <p>Paciência</p>
                  <OptionBox
                    selected={important_characteristics.patience === 1}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 1, field: 'patience' }
                      })
                    }
                  >
                    1
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.patience === 2}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 2, field: 'patience' }
                      })
                    }
                  >
                    2
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.patience === 3}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 3, field: 'patience' }
                      })
                    }
                  >
                    3
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.patience === 4}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 4, field: 'patience' }
                      })
                    }
                  >
                    4
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.patience === 5}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 5, field: 'patience' }
                      })
                    }
                  >
                    5
                  </OptionBox>
                </div>
              ) : (
                <div className='fifth_question__option'>
                  <p>Localidade</p>
                  <OptionBox
                    selected={important_characteristics.locality === 1}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 1, field: 'locality' }
                      })
                    }
                  >
                    1
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.locality === 2}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 2, field: 'locality' }
                      })
                    }
                  >
                    2
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.locality === 3}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 3, field: 'locality' }
                      })
                    }
                  >
                    3
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.locality === 4}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 4, field: 'locality' }
                      })
                    }
                  >
                    4
                  </OptionBox>
                  <OptionBox
                    selected={important_characteristics.locality === 5}
                    className='fifth_question__option__item'
                    onClick={() =>
                      dispatch({
                        type: 'set_important_characteristics',
                        payload: { value: 5, field: 'locality' }
                      })
                    }
                  >
                    5
                  </OptionBox>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='step__question__info'>
          <div className='step__question__info__next-step-container'>
            <div className='step__question__info__next-step-container__navigation'>
              <button
                className='button-verm-leaked match-maker-button mr-3'
                onClick={goToPreviousStep}
              >
                Voltar
              </button>
              <button
                disabled={isFifthStepProgressDisabled()}
                className='button-verm match-maker-button'
                onClick={submitFifthStep}
                id='step5-matchmaking'
              >
                Próximo
              </button>
            </div>
            {state.current_step > 0 && (
              <ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export { FifthStep }
